import { render, staticRenderFns } from "./RecruitLp.vue?vue&type=template&id=1d0826da&scoped=true"
import script from "./RecruitLp.vue?vue&type=script&lang=js"
export * from "./RecruitLp.vue?vue&type=script&lang=js"
import style0 from "./RecruitLp.vue?vue&type=style&index=0&id=1d0826da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0826da",
  null
  
)

export default component.exports